import TeamsLogin from "./TeamsLogin";

export default TeamsLogin;
